import { Drawer } from "antd";

import type { BaseDrawerProps } from "./types";

const BaseDrawer = ({ children, ...props }: BaseDrawerProps) => {
  return <Drawer {...props}>{children}</Drawer>;
};

export default BaseDrawer;
